module.exports = __webpack_public_path__ + "static/tokr-personal-596a31909258a582c786bffa352ca002.jpg";